/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actual_Nimble_Gadfly_PopInputs */

const fr_actual_nimble_gadfly_pop = /** @type {(inputs: Actual_Nimble_Gadfly_PopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue`)
};

/**

* @param {Actual_Nimble_Gadfly_PopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const actual_nimble_gadfly_pop = /** @type {((inputs?: Actual_Nimble_Gadfly_PopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actual_Nimble_Gadfly_PopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_actual_nimble_gadfly_pop(inputs)
});